'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';

import {
    AppContext,
    DataLinkContainer,
    ScrollableDataList,
} from 'plugin/liferay-widgets-react-web';

import { getChangeRecordStore } from '../stores/StoreFactory';
import ChangeRecordActions from '../actions/ChangeRecordActions';
import ChangeRecordListItem from './ChangeRecordListItem';

const ChangeRecordListLink = DataLinkContainer.link(ScrollableDataList, 'list', getChangeRecordStore(AppContext));

const ChangeRecordList = ({ dataChangeRecords }) => {

    const moreChangeRecords = (query) => {
        ChangeRecordActions.moreItems(dataChangeRecords, query);
    };

    return (
        <ChangeRecordListLink list={dataChangeRecords}
                              ListItem={ChangeRecordListItem}
                              listSize={ScrollableDataList.LIST_SIZE_LARGE}
                              onClickMore={moreChangeRecords.bind(this)}/>
    )
};

ChangeRecordList.propTypes = {
    dataChangeRecords: PropTypes.string.isRequired
};

export default ChangeRecordList;



// WEBPACK FOOTER //
// ./js/components/ChangeRecordList.jsx